export default __webpack_public_path__ + "static/media/Profile.3531828a.svg";